<template>
    <div class="rezultati">
        <!-- navbar -->
        <Navbar showBackButton></Navbar>

        <!-- poveznice -->
        <div class="poveznice">
            <Poveznice></Poveznice>
        </div>

        <div class="container cnt-pokreni">
            <PanelPokreni v-if="appState == 'round-in-progress'"/>
        </div>

        <div class="container cf">

            <!-- povijst bodova -->
            <div class="povijest">
                <transition name="fade-translate" appear>
                    <PovijestBodova v-model="ligaSelected"></PovijestBodova>
                </transition>
            </div>

            <!-- lista rezultata -->
            <div>
                <transition name="fade-translate" appear>
                    <ListaRezultata :ligaSelected="ligaSelected"></ListaRezultata>
                </transition>
            </div>
        </div>

    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Poveznice from '../components/Poveznice.vue'
import PovijestBodova from '../components/PovijestBodova.vue'
import ListaRezultata from '../components/ListaRezultata.vue'
import PanelPokreni from '../components/PanelPokreni'

export default {
    name: 'rezultati',
    data () {
        return {
            ligaSelected: null
        }
    },
    computed: {
        appState () {
            return this.$store.state.appState
        }
    },
    components: {
        Navbar,
        Poveznice,
        PovijestBodova,
        ListaRezultata,
        PanelPokreni
    }
}
</script>

<style lang="scss" scoped>
.rezultati {
    padding: 22px 0 40px 0;
    .poveznice {
      margin-bottom: 36px;
    }
    .povijest {
        margin-bottom: 60px;
    }
    .panel-pokreni {
        margin-bottom: 60px;
    }
}

@media only screen and (min-width: 800px) {
    .rezultati {
        max-width: 1280px;
        margin: auto;
        .container:not(.cnt-pokreni) {
            margin-left: -24px;

            > div {
                float: left;
                width: 50%;
                padding-left: 24px;
            }
        }
    }
}
</style>
